import { avatarMode } from '../../../consts.js';
export const Advisor_UserType_SBOrders = 'sandbox-orders';
export const Advisor_UserType_SBNLP = 'sandbox-nlp';
export const Advisor_UserType_SBFHIRQuery = 'sandbox-FHIR-query';
export const Advisor_UserTypes_SB = [Advisor_UserType_SBOrders, Advisor_UserType_SBNLP, Advisor_UserType_SBFHIRQuery];
export const Advisor_UserTypes = ['physician', 'nurse', ...Advisor_UserTypes_SB, avatarMode];
//# sourceMappingURL=types.js.map